import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {ICurationItem} from "../../interfaces/curation-item.interface";
import {get} from 'lodash';


@Component({
  selector: 'ispm-curation-item-not-found',
  templateUrl: './curation-item-not-found.component.html',
  styleUrls: ['./curation-item-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationItemNotFoundComponent implements OnInit {
  public payload: any;
  public tunnel$: Subject<any>;
  public callback: (model) => Observable<Response>;

  public curationItem: ICurationItem;
  public curationType: string;
  public curationItemId: string;
  constructor() {
  }

  ngOnInit() {
    this.tunnel$.asObservable().filter(value => value.emitter !== 'child').subscribe(next => {
      next.value && this.submit(this.payload);
    });
    this.curationType = get(this.payload, 'curationType', undefined);
    this.curationItem = get(this.payload, 'curationItem', undefined);
    this.curationItemId = !!this.curationItem ? get(this.curationItem, 'curationItemId', undefined): undefined;
  }

  submit(model) {
    this.callback(model)
      .subscribe((model) => {
        this.tunnel$.next({emitter: 'child', value: model});
      });
  }

}
